import { logout } from '#client/constants/routes';

export const AUTH_ERROR_CODES = ['UNAUTHENTICATED', 'FORBIDDEN', 'AUTH_EXCEPTION'];

export default function globalGraphQLErrorHandler({ errors }) {
  // Ignore account read errors here, so we can handle in component

  const authError = errors.find(
    ({ errorCode }) => AUTH_ERROR_CODES.includes(errorCode)
  );

  // If someone provides a bad UUID, force re-login
  const invalidBusinessEntityUuidError = errors.find(
    ({
      errorCode,
      message
    }) => (
      (errorCode === 'FORBIDDEN' && message === 'Permission failure')
      || (errorCode === 'BAD_USER_INPUT' && message.includes('UUID cannot represent non-UUID'))
    )
  );
    /* if the user is trying to access a resource that returns 403 take them
        to the "home" page of the dashboard.
    */
  if (authError || invalidBusinessEntityUuidError) {
    const { pathname } = window.location;
    if (!pathname || !pathname.startsWith(logout)) {
      window.location.assign(`${logout}?redirectTo=${pathname}`);
    }
  }
}
